"use client";

import { Logger, ProxyTransport } from "@axiomhq/logging";
import { createUseLogger, createWebVitalsComponent } from "@axiomhq/react";
import { nextJsFormatters } from "@axiomhq/nextjs/client";

export const logger = new Logger({
    transports: [new ProxyTransport({ url: "/api/axiom", autoFlush: true })],
    formatters: nextJsFormatters,
});

const useLogger = createUseLogger(logger);
const WebVitals = createWebVitalsComponent(logger);

export { useLogger, WebVitals };
